
import { defineComponent } from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import FilterSection from "./FilterSection.vue";

export default defineComponent({
    name: "FilterHolder",
    components: {
        FilterSection
    },
    computed: {
        ...mapState(['filter']),
        ...mapGetters({
            changedSlides: 'getChangedSlides',
            selectedChecks: 'getFilterSelection'
        })
    },
    methods: mapActions({
        clearFilter: 'CLEAR_FILTRATION'
    })
});
